// removed by extract-text-webpack-plugin
module.exports = {"barColor":"#e75649","barActiveColor":"#fc9e23","highlightColor":"#fc9e23","filtersWidth":"310px","filtersMarginLeft":"20px"};


//////////////////
// WEBPACK FOOTER
// ./src/css/stat.css
// module id = 94
// module chunks = 0